import { useEffect } from 'react';
import './App.css';
import $ from 'jquery';
import AOS from 'aos'
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Apropos from './components/Apropos';
import Services from './components/Services';
import Skills from './components/Skills';
import Works from './components/Works';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  //chargement
  $(window).on("load", function () {
    if ($("#preloader").length) {
      $("#preloader")
        .delay(100)
        .fadeOut("slow", function () {
          $(this).remove();
        });
    }
  });

  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: true
    })
  },[])

  return (
    <div>
      {/* <div id="preloader">
        <h2 className="name-load  animate-charcter">C H A R G E M E N T</h2>
      </div> */}
      <div className='homepage'>
        <Navbar/>
        <Hero/>
      </div>
      <Apropos/>
      <Services/>
      <Skills/>
      <Works/>
      <Contact/>
      <Footer/>
    </div>
  );
}

export default App;
